// extracted by mini-css-extract-plugin
export default {"page-error-holder":"page-not-found_page-error-holder__Rps8A"};